export default {
  data() {
    return {
      mobileDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortClients(this.teamsSettings[this.$route.params.team].listsSettings.clients.order.col, "ASC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortClients(this.teamsSettings[this.$route.params.team].listsSettings.clients.order.col, "DESC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
        {
          title: this.$t("dropdowns.sortingBy"),
          options: [
            {
              label: this.$t("client.name"),
              key: "last_name",
              method: () => {
                this.sortClients(
                  "last_name",
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.company"),
              key: "company",
              method: () => {
                this.sortClients(
                  "company",
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.email"),
              key: "email",
              method: () => {
                this.sortClients("email", this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir);
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.projects"),
              key: "projects_count",
              method: () => {
                this.sortClients(
                  "projects_count",
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.updated"),
              key: "updated_at",
              method: () => {
                this.sortClients(
                  "updated_at",
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.created"),
              key: "created_at",
              method: () => {
                this.sortClients(
                  "created_at",
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.order.dir
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      sortMainColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          key: "last_name",
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortClients("last_name", "ASC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortClients("last_name", "DESC");
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      showAsFirstColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          disabled: false,
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortClients(
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.showAs.firstCol.key,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortClients(
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.showAs.firstCol.key,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
          ],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("client.company"),
              key: "company",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.company",
                      key: "company",
                      format: "none",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.street"),
              key: "street",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.street",
                      key: "street",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.zip"),
              key: "zip",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.zip",
                      key: "zip",
                      format: "none",
                      size: 1,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.city"),
              key: "city",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.city",
                      key: "city",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.country"),
              key: "country",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.country",
                      key: "country",
                      format: "country",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.email"),
              key: "email",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.email",
                      key: "email",
                      format: "none",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.tel"),
              key: "tel",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.tel",
                      key: "tel",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.fax"),
              key: "fax",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.fax",
                      key: "fax",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.mobile"),
              key: "mobile",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.mobile",
                      key: "mobile",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.website"),
              key: "website",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.website",
                      key: "website",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.gender"),
              key: "gender",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.gender",
                      key: "gender",
                      format: "gender",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.projects"),
              key: "projects_count",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.projects",
                      key: "projects_count",
                      format: "none",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.notes"),
              key: "notes",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.notes",
                      key: "notes",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.reference"),
              key: "reference",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.reference",
                      key: "reference",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.updated"),
              key: "updated_at",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.updated",
                      key: "updated_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.created"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    firstCol: {
                      label: "client.created",
                      key: "created_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      showAsSecondColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          disabled: false,
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortClients(
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.showAs.secondCol.key,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortClients(
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.showAs.secondCol.key,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
          ],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("client.company"),
              key: "company",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.company",
                      key: "company",
                      format: "none",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.street"),
              key: "street",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.street",
                      key: "street",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.zip"),
              key: "zip",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.zip",
                      key: "zip",
                      format: "none",
                      size: 1,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.city"),
              key: "city",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.city",
                      key: "city",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.country"),
              key: "country",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.country",
                      key: "country",
                      format: "country",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.email"),
              key: "email",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.email",
                      key: "email",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.tel"),
              key: "tel",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.tel",
                      key: "tel",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.fax"),
              key: "fax",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.fax",
                      key: "fax",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.mobile"),
              key: "mobile",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.mobile",
                      key: "mobile",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.website"),
              key: "website",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.website",
                      key: "website",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.gender"),
              key: "gender",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.gender",
                      key: "gender",
                      format: "gender",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.projects"),
              key: "projects_count",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.projects",
                      key: "projects_count",
                      format: "none",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.notes"),
              key: "notes",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.notes",
                      key: "notes",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.reference"),
              key: "reference",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.reference",
                      key: "reference",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.updated"),
              key: "updated_at",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.updated",
                      key: "updated_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.created"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    secondCol: {
                      label: "client.created",
                      key: "created_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      showAsThirdColDropdown: [
        {
          title: this.$t("dropdowns.sortingDirection"),
          disabled: false,
          options: [
            {
              label: this.$t("dropdowns.asc"),
              key: "ASC",
              method: () => {
                this.sortClients(
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.showAs.thirdCol.key,
                  "ASC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
            {
              label: this.$t("dropdowns.desc"),
              key: "DESC",
              method: () => {
                this.sortClients(
                  this.teamsSettings[this.$route.params.team].listsSettings.clients.showAs.thirdCol.key,
                  "DESC"
                );
              },
              icon: "Icon=check.svg",
              hoverBg: true,
              disabled: false,
            },
          ],
        },
        {
          title: this.$t("dropdowns.showAs"),
          options: [
            {
              label: this.$t("client.company"),
              key: "company",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.company",
                      key: "company",
                      format: "none",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.street"),
              key: "street",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.street",
                      key: "street",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.zip"),
              key: "zip",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.zip",
                      key: "zip",
                      format: "none",
                      size: 1,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.city"),
              key: "city",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.city",
                      key: "city",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.country"),
              key: "country",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.country",
                      key: "country",
                      format: "country",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.email"),
              key: "email",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.email",
                      key: "email",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.tel"),
              key: "tel",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.tel",
                      key: "tel",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.fax"),
              key: "fax",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.fax",
                      key: "fax",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.mobile"),
              key: "mobile",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.mobile",
                      key: "mobile",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.website"),
              key: "website",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.website",
                      key: "website",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.gender"),
              key: "gender",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.gender",
                      key: "gender",
                      format: "gender",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.projects"),
              key: "projects_count",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.projects",
                      key: "projects_count",
                      format: "none",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.notes"),
              key: "notes",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.notes",
                      key: "notes",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.reference"),
              key: "reference",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.reference",
                      key: "reference",
                      format: "none",
                      size: 2,
                      sortable: false,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.updated"),
              key: "updated_at",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.updated",
                      key: "updated_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
            {
              label: this.$t("client.created"),
              key: "created_at",
              method: () => {
                this.changeCol({
                  list: "clients",
                  showAs: {
                    thirdCol: {
                      label: "client.created",
                      key: "created_at",
                      format: "date",
                      size: 2,
                      sortable: true,
                    },
                  },
                });
              },
              icon: "Icon=check.svg",
              hoverBg: true,
            },
          ],
        },
      ],
      filterDropdown: [
        {
          title: this.$t("filters.filterClients"),
          options: [
            {
              label: this.$t("filters.myClients"),
              switch: {
                name: "is_mine",
                model: true,
              },
              checkbox: true,
              method: () => {},
              hoverBg: true,
            },
            {
              label: this.$t("filters.withTags"),
              select: {
                name: "with_tag",
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectTag"),
                wrap: true,
                searchable: true,
                internalSearch: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: true,
            },
            {
              label: this.$t("filters.withoutTags"),
              select: {
                name: "without_tag",
                multiple: true,
                model: [],
                options: [],
                label: "label",
                placeholder: this.$t("placeholders.selectTag"),
                wrap: true,
                searchable: true,
                internalSearch: true,
                searchChange: () => {},
              },
              method: () => {},
              checkbox: true,
              hoverBg: true,
              hideIfNoOptions: true,
            },
            {
              label: this.$t("filters.activateFilter"),
              border: "border-top",
              color: "primary",
              position: "center",
              method: () => {
                this.setClientsFilters();
              },
              noActiveState: true,
              button: true,
            },
            {
              label: this.$t("filters.resetFilter"),
              color: "text-danger",
              position: "center",
              method: () => {
                this.resetFilters(this.setClientsFilters);
              },
              hoverBg: true,
              noActiveState: true,
            },
          ],
        },
      ],
    };
  },
};
